/* ─── REVIEWS CAROUSEL ─── */
(function () {
  var track   = document.getElementById('ps-track');
  var prev    = document.getElementById('ps-prev');
  var next    = document.getElementById('ps-next');
  var dotsEl  = document.getElementById('ps-dots');
  var cards   = Array.from(track.querySelectorAll('.ps-card'));
  var idx     = 0, timer;
 
  function vis()    { return window.innerWidth > 900 ? 3 : window.innerWidth > 600 ? 2 : 1; }
  function maxIdx() { return Math.max(0, cards.length - vis()); }
  function gap()    { return cards[0].offsetWidth + 20; }
 
  function render() {
    idx = Math.max(0, Math.min(idx, maxIdx()));
    track.style.transform = 'translateX(-' + idx * gap() + 'px)';
    prev.disabled = idx === 0;
    next.disabled = idx >= maxIdx();
    dotsEl.querySelectorAll('.ps-dot').forEach(function (d, i) {
      d.classList.toggle('active', i === idx);
    });
  }
 
  function buildDots() {
    dotsEl.innerHTML = '';
    for (var i = 0; i <= maxIdx(); i++) {
      var d = document.createElement('button');
      d.className = 'ps-dot' + (i === 0 ? ' active' : '');
      d.setAttribute('aria-label', 'Go to review ' + (i + 1));
      (function(n){ d.addEventListener('click', function(){ idx = n; render(); kick(); }); })(i);
      dotsEl.appendChild(d);
    }
  }
 
  function kick() {
    clearInterval(timer);
    timer = setInterval(function () {
      idx = idx >= maxIdx() ? 0 : idx + 1; render();
    }, 4500);
  }
 
  prev.addEventListener('click', function () { idx--; render(); kick(); });
  next.addEventListener('click', function () { idx++; render(); kick(); });
 
  var sec = document.getElementById('ps-reviews-section');
  sec.addEventListener('mouseenter', function () { clearInterval(timer); });
  sec.addEventListener('mouseleave', function () { kick(); });
 
  var tx = 0;
  track.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend',   function (e) {
    var d = tx - e.changedTouches[0].clientX;
    if (Math.abs(d) > 44) { idx += d > 0 ? 1 : -1; render(); kick(); }
  });
 
  window.addEventListener('resize', function () { buildDots(); render(); });
  buildDots(); render(); kick();
})();
 
/* ─── FAQ ACCORDION ─── */
(function () {
  var items = Array.from(document.querySelectorAll('.ps-faq__item'));
  items.forEach(function (item) {
    var btn = item.querySelector('.ps-faq__q');
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      /* Close all */
      items.forEach(function (it) {
        it.classList.remove('open');
        it.querySelector('.ps-faq__q').setAttribute('aria-expanded', 'false');
      });
      /* Toggle clicked */
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();